// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610010127/js/" + chunkId + "." + {"44":"54330368","225":"2c659ef2","481":"7c5f4d5c","486":"8c816c71","770":"7934486e"}[chunkId] + ".0.7577793830517148.chunk.js";
};